<template>
    <div ref="littleDevilWrap"
         class="littleDevilWrap"
         @click.stop="isShow = !isShow">
        <el-popover
                v-model="firstTips"
                placement="top"
                width="200"
                trigger="manual"
                @hide="firstTipsHideCb">
            <p>{{$t('message.dear')}}{{$t('message.$space')}}{{loginData.nickname ||
                $t('message.notNickname')}}{{$t('message.$comma')}}{{$t('message.assistantTips')}}</p>
            <div style=" margin: 0; text-align: right;">
                <el-button type="text" @click="firstTips = false">{{$t('message.iKnow')}}</el-button>
            </div>
            <div slot="reference"
                 class="headBox"
                 :class="{newMsg:newMsg}">
                <div class="earBox">
                    <div class="earL"></div>
                    <div class="earR"></div>
                </div>
                <div class="faceBox">
                    <div ref="eyeL" class="eyeL"></div>
                    <div ref="eyeR" class="eyeR"></div>
                    <div ref="mouthBox" class="mouthBox">
                        <div class="mouth"></div>
                    </div>
                </div>
                <div :class="{hasData:operatingData.length}" class="remindBox">{{operatingData.length}}</div>
            </div>
        </el-popover>
        <transition name="littleDevilMessageWrap">
            <div v-show="isShow"
                 class="messageWrap"
                 @click.stop>
                <div class="messageBox">
                    <div class="messageContent">
                        <div class="messageContentScroll" :style="`top: -${100*Number(messageTabActive)}%;`">
                            <div class="operatingWrap">
                                <div v-if="operatingData.length && isRealShow" class="operatingCarouselWrap">
                                    <div class="swiper-wrapper">
                                        <div v-for="(item,index) in operatingData"
                                             :key="index"
                                             class="swiper-slide">
                                            <div class="productInfoBox">
                                                <div class="productNameBox">
                                                    <div class="productName">{{item.productName}}</div>
                                                    <div class="intoCabinType">
                                                        {{item.intoCabinType==='0'?$t('message.notInStorage'):$t('message.inStorage')}}
                                                    </div>
                                                </div>
                                                <div class="airlineBox">
                                                    <div class="airlineImgBox">
                                                        <div class="airlineImg"
                                                             :style="`background-image: url('${item.airlineImg}')`"></div>
                                                    </div>
                                                    <div class="startPortBox">
                                                        <p class="tit">{{$t('message.startPort')}}</p>
                                                        <p class="portBox">
                                                            <span class="port">{{item.startPort}}</span>
                                                            <span class="portName">{{item.startPortName}}</span>
                                                        </p>
                                                    </div>
                                                    <div class="productDateBox">
                                                        <p v-if="$i18n.locale === 'zhCHS'" class="productDate">
                                                            {{$moment(item.shippingDate).format('MM月DD日')}}
                                                        </p>
                                                        <p v-else class="productDate">
                                                            {{$moment(item.shippingDate).format('YYYY-MM-DD')}}
                                                        </p>
                                                        <p class="icon">
                                                            <i class="iconfont icon-plane"></i>
                                                        </p>
                                                    </div>
                                                    <div class="destinationBox">
                                                        <p class="tit">{{$t('message.endPort')}}</p>
                                                        <p class="portBox">
                                                            <span class="port">{{item.destination}}</span>
                                                            <span class="portName">{{item.destinationName.split('，')[0]}}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div v-if="item.intoCabinType === '0'" class="goodsDataBox">
                                                    {{$t('message.bookingData')}}
                                                    {{item.bookingData.pieces}}PCS | {{item.bookingData.weight}}KG |
                                                    {{item.bookingData.volume}}CBM | 1:{{item.bookingData.proportion}}
                                                </div>
                                                <div v-if="item.intoCabinType === '1'" class="goodsDataBox">
                                                    {{$t('message.entryData')}}
                                                    {{item.intoCabin.pieces}}PCS | {{item.intoCabin.weight}}KG |
                                                    {{item.intoCabin.volume}}CBM | 1:{{item.intoCabin.proportion}}
                                                </div>
                                            </div>
                                            <div class="productDataBox">
                                                <div v-if="item.type==='3'" class="notPassed">
                                                    <div class="cry">
                                                        <i class="iconfont icon-bukaixin"></i>
                                                    </div>
                                                    <div class="textBox">
                                                        <div class="txt1">{{$t('message.sorryAuditNotPassed')}}</div>
                                                        <div :title="`${$t('message.reason')}${$t('message.$colon')}${item.cancelReason||$t('message.not')}`"
                                                             class="txt2">
                                                            {{$t('message.reason')}}{{$t('message.$colon')}}{{item.cancelReason||$t('message.not')}}
                                                        </div>
                                                        <div class="txt3">{{$t('message.contactCustomerService')}}</div>
                                                    </div>
                                                </div>
                                                <div v-else class="dataDetailBox">
                                                    <div class="dataDetail">
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.waybillNumber')}}</p>
                                                            <span :title="item.waybillCode||'- -'">{{item.waybillCode||'- -'}}</span>
                                                        </div>
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.unitPrice')}}</p>
                                                            <span :title="`${$currencyAbbr(item.currencyType)}${item.unitPrice||'- -'}`">{{$currencyAbbr(item.currencyType)}}{{item.unitPrice||'- -'}}</span>
                                                        </div>
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.storageSize')}}</p>
                                                            <span :title="operationIntoCabinSize(item.intoCabinSize)||'- -'">{{operationIntoCabinSize(item.intoCabinSize)||'- -'}}</span>
                                                        </div>
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.splittingRatio')}}</p>
                                                            <span :title="item.bubbleRatio||'- -'">{{item.bubbleRatio||'- -'}}</span>
                                                        </div>
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.flightCode')}}</p>
                                                            <span :title="item.flightCode||'- -'">{{item.flightCode||'- -'}}</span>
                                                        </div>
                                                        <div class="dataItem">
                                                            <p class="tit">{{$t('message.boardGroup')}}</p>
                                                            <span :title="item.boardGroupName||'- -'">{{item.boardGroupName||'- -'}}</span>
                                                        </div>
                                                    </div>
                                                    <a :href="operationBtnLink(item)"
                                                       target="_blank"
                                                       class="operatingBtn">{{operationBtnText(item.type)}}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="swiperIndex!==0" class="prevBtn">
                                        <i class="iconfont icon-zuo1"></i>
                                    </div>
                                    <div v-show="swiperIndex!==operatingData.length-1 && operatingData.length"
                                         class="nextBtn">
                                        <i class="iconfont icon-you"></i>
                                    </div>
                                </div>
                                <div v-if="!operatingData.length" class="noData">{{$t('message.notToDo')}}</div>
                                <SJMLoading v-if="!isRealShow"
                                            top="50%"
                                            type="chrome"
                                            zIndex="10"></SJMLoading>
                            </div>
                            <div v-if="!$overseasType" class="csWrap">
                                <a :href="customerServiceQQ"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '出口客服')">
                                    <img src="../assets/img/littleDevil/gongying.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.exportCustomerService')}}</div>
                                </a>
                                <a :href="$pcOrMobileQQ('2880132837')"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '出口操作经理')">
                                    <img src="../assets/img/littleDevil/chukoujingli.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.exportOperationsManager')}}</div>
                                </a>
                                <a :href="$pcOrMobileQQ('2880132761')"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '售后理赔')">
                                    <img src="../assets/img/littleDevil/shouhou.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">
                                        <p>{{$t('message.anomaly')}}</p>
                                        <p>{{$t('message.afterSalesClaims')}}</p>
                                    </div>
                                </a>
                                <a :href="$pcOrMobileQQ(customerService.supplierQQ)"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '供应商客服')">
                                    <img src="../assets/img/littleDevil/gongying.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.supplierCustomerService')}}</div>
                                </a>
                                <a :href="$pcOrMobileQQ('2880132763')"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '投诉建议')">
                                    <img src="../assets/img/littleDevil/advice.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.complaintsAndSuggestions')}}</div>
                                </a>
                               
                                <a :href="$pcOrMobileQQ(customerService.importQQ)"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-客服', '小恶魔-客服', '进口客服')">
                                    <img src="../assets/img/littleDevil/gongying.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.importCustomerService')}}</div>
                                </a>        
                            </div>


                            <div v-else class="csWrap">
                                <div class="toolsBox"
                                     @click="customerServiceEmail();$bigData('小恶魔-客服', '小恶魔-客服', '客服')">
                                    <i class="iconfont icon-kefu1" style="top: 13px; font-size: 44px;"></i>
                                    <div class="txt" style="top: -3px;">{{$t('message.cs')}}</div>
                                </div>
                            </div>
                            <div class="miaoToolsWrap">
                                <a href="/tools/MiscellaneousBillsList"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', '杂费清单')">
                                    <img src="../assets/img/littleDevil/qingdan.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">
                                        {{$t('message.miscellaneousBillsList')}}
                                    </div>
                                </a>
                                <a href="/tools/DeliveryInformation"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', '交货资料')">
                                    <i class="iconfont icon-peisong"></i>
                                    <div class="txt" style="width: 120px;">{{$t('message.deliveryInformation')}}</div>
                                </a>
                                <!-- <a href="http://222.73.210.139/pactl/bill_query.php"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', 'PVG货运站')">
                                    <i class="iconfont icon-huoyun" style="top: 13px; font-size: 44px;"></i>
                                    <div class="txt" style="top: -2px; width: 120px;">
                                        {{$t('message.friendshipLinkText2')}}
                                    </div>
                                </a> -->
                                <!-- <a :href="jiangHuLinkRenderer(jiangHuImgList[0])||'javascript:void(0);'"
                                   :target="jiangHuLinkRenderer(jiangHuImgList[0])?'_blank':'_self'"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', '货值险')">                                
                                    <img src="../assets/img/littleDevil/huozhixian.png" style="position: relative; top: 10px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.cargoValueInsurance')}}</div>
                                </a> -->
                                <a :href="'javascript:void(0);'"
                                   class="toolsBox"
                                   @click="qidaihuozhi = true;$Alert({ msg: '敬请期待！',callback:() => { qidaihuozhi = false}}); $bigData('小恶魔-喵工具','小恶魔-喵工具','货值险')"
                                >                                
                                    <img src="../assets/img/littleDevil/huozhixian.png" style="position: relative; top: 10px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.cargoValueInsurance')}}</div>
                                </a>
                                <a href="http://www.aircargotracking.net/aircargo-tracking.html"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', '跟踪查询')">
                                    <i class="iconfont icon-renwuchaxun"></i>
                                    <div class="txt" style="width: 120px;">{{$t('message.friendshipLinkText3')}}</div>
                                </a>
                                <a href="http://www.i5a6.com/hscode/"
                                   target="_blank"
                                   class="toolsBox"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', 'HS编码')">
                                    <img src="../assets/img/littleDevil/HSbianma.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.HSCoding')}}</div>
                                </a>
                                <a href="/tools/ImportDatabase"
                                   target="_blank"
                                   class="toolsBox"
                                   style="border-bottom: none;"
                                   @click="$bigData('小恶魔-喵工具', '小恶魔-喵工具', '进口资料库')">
                                    <img src="../assets/img/littleDevil/jinkou.png" style="position: relative; top: 15px; width: 35px;"/>
                                    <div class="txt" style="width: 120px;">{{$t('message.importDatabase')}}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="messageTab">
                        <!-- 消息阴影盒子 -->
                        <div class="messageShadowBox">
                            <div class="messageShadow"></div>
                            <div class="messageShadow"></div>
                            <div class="messageShadow"></div>
                        </div>
                        <!-- 消息盒子 -->
                        <div class="messageItemBox">
                            <div class="messageItem"
                                 :class="{active:messageTabActive==='0'}"
                                 @click="messageTabClick('0');$bigData('小恶魔-待办事项', '小恶魔-待办事项', '1')">
                                <i class="iconfont icon-daiban"></i>
                                <span>{{$t('message.toDo')}}</span>
                            </div>
                            <div class="messageItem"
                                 :class="{active:messageTabActive==='1'}"
                                 @click="messageTabClick('1');$bigData('小恶魔-联系我们', '小恶魔-联系我们', '1')">
                                <!-- <i class="iconfont icon-kefu"></i> -->                         
                                <img v-if="messageTabActive === '1'" 
                                     src="../assets/img/littleDevil/whiteKefu.png"
                                     style="position: relative; top: 10px; width: 30px;"/>
                                <img v-else 
                                     src="../assets/img/littleDevil/gongying.png"
                                     style="position: relative; top: 10px; width: 30px;"/>
                                <span>{{$t('message.contactUs')}}</span>
                            </div>
                            <div class="messageItem"
                                 :class="{active:messageTabActive==='2'}"
                                 @click="messageTabClick('2');$bigData('小恶魔-喵工具', '小恶魔-喵工具', '1')">
                                <i class="iconfont icon-haofangtuoiconfont_yingxiaogongju"></i>
                                <span>{{$t('message.catTool')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <audio ref="audio">
            <!--            <source src="@/assets/audio/littleDevilNewMsg.ogg" type="audio/ogg"/>-->
            <source src="@/assets/audio/littleDevilNewMsg.mp3" type="audio/mpeg"/>
        </audio>
    </div>
</template>

<script>
    export default {
        name: 'LittleDevil',// 小恶魔
        data() {
            return {
                isShow: false,// 显示小恶魔
                isRealShow: false,// 小恶魔显示并渲染完毕
                isRealShowTimer: null,// 小恶魔真实渲染延时器Timer
                getDataAjax: null,// 获取数据Ajax对象
                roundAjaxTimer: null,// 轮循Ajax延时器Timer
                messageTabActive: '0',// 当前选中的菜单
                newOperatingData: false,// 新数据标志位
                carouselInstance: null,// 轮播图实例
                operatingData: [],// 待办事项数据,
                swiperIndex: 0,// 轮播当前下标
                eyeX: 0,// 眼睛左右偏移
                eyeY: 0,// 眼睛上下偏移
                newMsg: false,// 小恶魔新消息提醒标志
                newMsgTimer: null,// 新消息提醒延时器Timer
                firstTips: false,// 小恶魔首次提醒
                nowData: '',// 当前数据
                newData: '',// 新数据
                localData: '',// local缓存数据
                jiangHuImgList: [],// 江湖数据
                customerService: {},
                qidaihuozhi: false, // 货值敬请期待
            };
        },
        computed: {
            // 客服Email
            customerServiceEmail() {
                return () => {
                    this.$emailContactUs({
                        email: this.$store.state.importEmailCustomerServiceEmail
                    });
                };
            },
            // 客服QQ
            customerServiceQQ() {
                return this.$pcOrMobileQQ(this.$store.state.customerServiceQQ);
            },
            // 用户登录信息
            loginData() {
                return this.$store.state.Login.loginData;
            }
        },
        watch: {
            isShow(newValue) {
                if (newValue) {
                    // 当打开小恶魔，并过度动画完毕后
                    this.isRealShowTimer = setTimeout(() => {
                        this.isRealShow = true;// 小恶魔渲染完毕
                    }, 300);
                    // 打开小恶魔关闭提醒
                    this.newMsg = false;
                    // 并清除提醒定时器
                    clearTimeout(this.newMsgTimer);
                    // 关闭首次Tips弹窗
                    this.firstTips = false;
                } else {
                    clearTimeout(this.isRealShowTimer);
                    // 解除swiper
                    if (this.carouselInstance) {
                        this.carouselInstance.destroy(false);
                    }
                    this.isRealShow = false;// 小恶魔非真实显示
                }
            },
            isRealShow(newValue) {
                // 渲染完毕
                if (newValue) {
                    this.$bigData('小恶魔-开启', '小恶魔-开启', '1');
                    this.carouselImgDataRenderer();// 渲染小恶魔轮播图
                }
            },
        },
        created() {
            // 点击屏幕关闭小恶魔
            document.addEventListener('click', () => {
                if (!this.qidaihuozhi) {
                    this.isShow = false;
                }             
            });
            // 获取小恶魔助理的数据
            this.getLittleDevilAssistantManagerData();
            // this.get2019IndexJiangHuData();
        },
        mounted() {
            // 小恶魔脸部表情跟随
            document.addEventListener('mousemove', this.faceFollow);// 脸部跟随方法
            document.addEventListener('mouseleave', this.faceLeave);// 脸部跟随方法

            // 获取小恶魔首次提醒标志
            const littleDevilFirstTipsHide = localStorage.getItem('littleDevilFirstTipsHide');

            // 如果从未提醒过
            if (!littleDevilFirstTipsHide) {
                setTimeout(() => {
                    this.firstTips = true;
                }, 1000);
            }
        },
        beforeDestroy() {
            clearTimeout(this.isRealShowTimer);// 小恶魔真实渲染Timer
            clearTimeout(this.roundAjaxTimer);// 轮循数据Timer
            document.removeEventListener('mousemove', this.faceFollow);// 解除小恶魔脸部跟随
            document.removeEventListener('mouseleave', this.faceLeave);// 解除脸部跟随方法

            // 解除swiper
            if (this.carouselInstance) {
                this.carouselInstance.destroy();
            }
        },
        methods: {
            // get2019IndexJiangHuData() {
            //    this.$ajax({
            //        url: '/HomeHandler/BannerHandler.ashx',
            //        data: {
            //            act: 'get2019IndexJiangHuData', // 获取江湖的数据
            //        },
            //        success: (res) => {
            //            // 渲染数据
            //            this.jiangHuImgList = res.success.jiangHuImgList;
            //        }
            //    });
            // },
            jiangHuLinkRenderer(item) {
                if (!item) {
                    return '';
                } else {
                    return item.link.trim();
                }
            },
            // 小恶魔tab切换
            messageTabClick(index) {
                // 选中状态赋值
                this.messageTabActive = index;
            },
            // 获取小恶魔助理的数据
            getLittleDevilAssistantManagerData() {
                this.$ajax({
                    name: 'getDataAjax',
                    bigData: false,
                    url: '/SmartProductsHandler/Home/NoticeMessageHandler.ashx',
                    data: {
                        act: 'getLittleDevilAssistantManagerData',// 获取小恶魔助理的数据
                    },
                    success: (res) => {

                        this.nowData = JSON.stringify(this.operatingData);// 当前数据
                        this.newData = JSON.stringify(res.success.operatingData);// 新数据
                        this.localData = localStorage.getItem('littleDevilData');// local缓存数据

                        // 绑定数据
                        this.customerService = res.success.customerService || {};

                        // 如果获取到老数据不继续执行
                        if (this.nowData === this.newData) {
                            return;
                        }

                        // 绑定数据
                        this.operatingData = res.success.operatingData;
                
                        // 获取到新数据
                        this.newOperatingData = true;

                        // 渲染完毕并且一定有新数据
                        if (this.isRealShow) {
                            this.carouselImgDataRenderer();// 渲染小恶魔轮播图
                        }

                        localStorage.setItem('littleDevilData', this.newData);

                        // 新数据和缓存数据不一致，并且不是空数据时
                        if (this.newData !== this.localData && this.newData !== '[]') {
                            this.$refs.audio.play();// 播放提示音
                            // 提示新消息
                            this.newMsg = true;
                            this.newMsgTimer = setTimeout(() => {
                                this.newMsg = false;// 10秒后关闭提醒
                            }, 9000);
                        }
                    },
                    complete: () => {
                        // this.roundAjaxTimer = setTimeout(() => {
                        //     this.getLittleDevilAssistantManagerData();// 获取小恶魔助理的数据
                        // }, 30000)
                    }
                });
            },
            // 脸部跟随方法
            faceFollow(e) {
                const windowW = this.$(window).width();// 屏幕宽度
                const windowH = this.$(window).height();// 屏幕高度

                const devilX = this.$refs.littleDevilWrap.offsetLeft + this.$refs.littleDevilWrap.clientWidth / 2;// 小恶魔X定位
                const devilY = this.$refs.littleDevilWrap.offsetTop + this.$refs.littleDevilWrap.clientHeight / 2;// 小恶魔Y定位

                const clientX = e.clientX;// 鼠标位置X
                const clientY = e.clientY;// 鼠标位置Y

                const zoom = 1;// 屏幕定位比例（>=1）

                const eyesXRange = 5;// 眼睛左右移动范围
                const eyesYRange = 5;// 眼睛上下移动范围

                let mouseXPct = (clientX - devilX) / windowW * zoom;// 鼠标X定位百分比
                let mouseYPct = (devilY - clientY) / windowH * zoom;// 鼠标Y定位百分比

                // 如果超过比例 还原成最大比例
                if (mouseXPct > 1) {
                    mouseXPct = 1;
                } else if (mouseXPct < -1) {
                    mouseXPct = -1;
                }
                if (mouseYPct > 1) {
                    mouseYPct = 1;
                } else if (mouseYPct < -1) {
                    mouseYPct = -1;
                }

                this.eyeX = mouseXPct * eyesXRange;// 眼睛左右偏移
                this.eyeY = mouseYPct * eyesYRange;// 眼睛上下偏移

                this.$refs.eyeL.style.left = `${15 + this.eyeX}px`;
                this.$refs.eyeL.style.bottom = `${25 + this.eyeY}px`;

                this.$refs.eyeR.style.right = `${15 - this.eyeX}px`;
                this.$refs.eyeR.style.bottom = `${25 + this.eyeY}px`;

                this.$refs.mouthBox.style.top = `${31 - this.eyeY}px`;
                this.$refs.mouthBox.style.left = `${15 + this.eyeX}px`;
            },
            // 离开脸部
            faceLeave() {
                this.eyeX = 0;
                this.eyeY = 0;
                this.$refs.eyeL.style.left = `${15 + this.eyeX}px`;
                this.$refs.eyeL.style.bottom = `${25 + this.eyeY}px`;

                this.$refs.eyeR.style.right = `${15 - this.eyeX}px`;
                this.$refs.eyeR.style.bottom = `${25 + this.eyeY}px`;

                this.$refs.mouthBox.style.top = `${31 - this.eyeY}px`;
                this.$refs.mouthBox.style.left = `${15 + this.eyeX}px`;
            },
            // 隐藏首次提醒回调
            firstTipsHideCb() {
                localStorage.setItem('littleDevilFirstTipsHide', '1');
            },
            // 渲染小恶魔轮播图
            carouselImgDataRenderer() {
                this.newOperatingData = false;// 已经渲染数据
                if (this.operatingData.length !== 0) {
                    this.$nextTick(() => {
                        this.carouselInstance = new this.$swiper('.littleDevilWrap .operatingCarouselWrap', {
                            paginationClickable: true,
                            effect: 'coverflow',
                            grabCursor: true,
                            centeredSlides: true,
                            slidesPerView: 'auto',
                            prevButton: '.littleDevilWrap .prevBtn',
                            nextButton: '.littleDevilWrap .nextBtn',
                            speed: 450,
                            coverflow: {
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: true
                            },
                            onDestroy: () => {
                                this.swiperIndex = 0;
                            },
                            onTransitionStart: (swiper) => {
                                this.swiperIndex = swiper.activeIndex;// 轮播当前下标
                            }
                        });
                    });
                }
            },
            // 操作按钮文字
            operationBtnText(type) {
                const list = {
                    0: this.$t('message.goToDataConfirmation'),
                    1: this.$t('message.goToMainOrderProduction'),
                    2: this.$t('message.goToFeeConfirmation')
                };
                return list[type];

            },
            // 操作按钮链接
            operationBtnLink({type, orderBillCode}) {
                const baseUrl = '/personalCenter/PersonalCenterMain';
                const list = {
                    0: `${baseUrl}/operationCenter/cargoQuery/exportBusiness/DataToConfirm?orderBillCode=${orderBillCode}`,
                    1: `${baseUrl}/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain?orderBillCode=${orderBillCode}`,
                    2: `${baseUrl}/operationCenter/cargoQuery/exportBusiness/CostConfirm?orderBillCode=${orderBillCode}`
                };
                return list[type];
            },
            // 入库尺寸渲染
            operationIntoCabinSize(sizeArr) {
                let size = '';
                sizeArr.map((item) => {
                    size += `${item.length || '--'}*${item.width || '--'}*${item.high || '--'}/${item.pieces || '--'};`;
                });
                return size;
            }
        }
    };
</script>

<style lang="scss" scoped>

    .littleDevilMessageWrap-enter-active,
    .littleDevilMessageWrap-leave-active {
        transition: all 0.25s;
    }

    .littleDevilMessageWrap-enter,
    .littleDevilMessageWrap-leave-to {
        transform: scale(0);
    }

    .littleDevilWrap {
        position: fixed;
        right: 100px;
        bottom: 100px;
        z-index: 999;
        width: 50px;
        height: 50px;
        cursor: pointer;
        border-radius: 50%;

        @keyframes headBox {
            50% {
                transform: scale3d(1, 1, 1);
            }

            55%,
            60% {
                transform: scale3d(0.85, 0.85, 0.85) rotate3d(0, 0, 1, -7deg);
            }

            65%,
            75%,
            85%,
            95% {
                transform: scale3d(1.15, 1.15, 1.15) rotate3d(0, 0, 1, 7deg);
            }

            70%,
            80%,
            90% {
                transform: scale3d(1.15, 1.15, 1.15) rotate3d(0, 0, 1, -7deg);
            }

            to {
                transform: scale3d(1, 1, 1);
            }
        }

        .headBox {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #29a3da;
            border-radius: 50%;
            box-shadow: 1px 1px 10px 1px #a5a5a5;

            &.newMsg {
                animation: headBox 1.5s alternate infinite;
            }

            .earBox {
                position: relative;

                .earL {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 10px;
                    height: 18px;
                    background-image: url("~@/assets/img/littleDevil/earL.png");
                    background-repeat: no-repeat;
                    background-size: 100%;
                }

                .earR {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 10px;
                    height: 18px;
                    background-image: url("~@/assets/img/littleDevil/earR.png");
                    background-repeat: no-repeat;
                    background-size: 100%;
                }
            }

            .faceBox {
                position: relative;
                height: 100%;

                @keyframes blink {
                    0% {
                        height: 8px;
                    }

                    92% {
                        height: 8px;
                    }

                    94% {
                        height: 0;
                    }

                    96% {
                        height: 8px;
                    }

                    98% {
                        height: 0;
                    }

                    100% {
                        height: 8px;
                    }
                }

                .eyeL,
                .eyeR {
                    position: absolute;
                    bottom: 25px;
                    width: 4px;
                    height: 9px;
                    background-color: white;
                    border-radius: 4px;
                    animation: blink 5.4s ease-in infinite;
                }

                .eyeL {
                    left: 15px;
                }

                .eyeR {
                    right: 15px;
                }

                .mouthBox {
                    position: absolute;
                    top: 31px;
                    left: 13px;
                    box-sizing: border-box;
                    width: 19px;
                    height: 7px;
                    padding: 0;
                }

                .mouth {
                    height: 100%;
                    background-color: white;
                    border-radius: 8px;
                }
            }

            .remindBox {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                font-size: 20px;
                line-height: 50px;
                color: white;
                text-align: center;
                user-select: none;
                background-color: #29a3da;
                border-radius: 50%;
                opacity: 0;
                transition: all 0.5s;

                &.hasData {
                    opacity: 1;
                }
            }
        }

        .messageWrap {
            position: absolute;
            right: -17px;
            bottom: 94px;
            width: 484px;
            height: 264px;
            border-radius: 6px;
            transform-origin: 444px 294px;

            .messageBox {
                position: relative;
                display: flex;
                height: 100%;
                border-radius: 6px;

                .messageContent {
                    width: 400px;
                    height: 100%;
                    overflow: hidden;
                    border-top-left-radius: 6px;
                    border-bottom-left-radius: 6px;

                    /* background-color: rgba(255, 255, 255, 0.9); */
                    box-shadow: 0 0 5px #c4c4c4;

                    &::before {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        content: '';
                        background-color: rgba(255, 255, 255, 0.95);
                        filter: blur(1px);
                        border-radius: 6px;
                    }

                    .messageContentScroll {
                        position: relative;
                        top: 0;
                        height: 300%;
                        transition: top 0.5s;

                        .operatingWrap {
                            position: relative;
                            box-sizing: border-box;
                            height: 264px;

                            .operatingCarouselWrap {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                overflow: hidden;

                                &:hover {
                                    .prevBtn {
                                        left: 13px;
                                        opacity: 1;
                                    }

                                    .nextBtn {
                                        right: 13px;
                                        opacity: 1;
                                    }
                                }

                                .prevBtn,
                                .nextBtn {
                                    position: absolute;
                                    top: 50%;
                                    left: 0;
                                    z-index: 1;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 36px;
                                    height: 36px;
                                    font-weight: bold;
                                    color: white;
                                    cursor: pointer;
                                    background-color: rgba(31, 45, 61, 0.11);
                                    border-radius: 50%;
                                    opacity: 0;
                                    transition: 0.3s all;
                                    transform: translateY(-50%) scale(0.8);

                                    &:hover {
                                        background-color: rgba(31, 45, 61, 0.23);
                                    }
                                }

                                .nextBtn {
                                    right: 0;
                                    left: auto;
                                }

                                .swiper-slide {
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    height: 100%;
                                    background-position: center;
                                    background-size: cover;

                                    .productInfoBox {
                                        box-sizing: border-box;
                                        display: flex;
                                        flex-direction: column;
                                        height: 125px;
                                        padding: 13px 18px 0 18px;
                                        background-color: rgba(41, 163, 218, 0.2);

                                        .productNameBox {
                                            display: flex;
                                            justify-content: space-between;
                                            height: 28px;
                                            border-bottom: 1px dashed rgba(153, 153, 153, 0.5);

                                            .productName {
                                                font-size: 16px;
                                                color: #4d4d4d;
                                            }

                                            .intoCabinType {
                                                font-size: 16px;
                                                color: #29a7de;
                                            }
                                        }

                                        .airlineBox {
                                            box-sizing: border-box;
                                            display: flex;
                                            height: 60px;
                                            padding-top: 9px;

                                            .airlineImgBox {
                                                width: 48px;

                                                .airlineImg {
                                                    width: 30px;
                                                    height: 30px;
                                                    background-color: #0071b8;
                                                    background-repeat: no-repeat;
                                                    background-position: center;
                                                    background-size: cover;
                                                    border-radius: 50%;
                                                }
                                            }

                                            .startPortBox {
                                                flex: 1;

                                                > .tit {
                                                    font-size: 12px;
                                                }

                                                .portBox {
                                                    display: flex;
                                                    align-items: center;

                                                    .port {
                                                        display: inline-block;
                                                        margin-right: 6px;
                                                        font-size: 16px;
                                                        color: #181818;
                                                    }

                                                    .portName {
                                                        display: inline-block;
                                                        width: 75px;
                                                        overflow: hidden;
                                                        font-size: 12px;
                                                        color: #181818;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    }
                                                }
                                            }

                                            .productDateBox {
                                                width: 85px;

                                                .productDate {
                                                    font-size: 12px;
                                                    color: #181818;
                                                    text-align: center;
                                                }

                                                .icon {
                                                    position: relative;
                                                    top: -3px;
                                                    text-align: center;

                                                    .iconfont {
                                                        position: relative;
                                                        top: 5px;
                                                        font-size: 22px;
                                                        color: #a4aab3;
                                                    }

                                                    &::before,
                                                    &::after {
                                                        position: absolute;
                                                        top: 15px;
                                                        width: 21px;
                                                        height: 1px;
                                                        content: '';
                                                        background-color: #a4aab3;
                                                        border-radius: 1px;
                                                    }

                                                    &::before {
                                                        left: 0;
                                                    }

                                                    &::after {
                                                        right: 0;
                                                    }
                                                }
                                            }

                                            .destinationBox {
                                                flex: 1;

                                                > .tit {
                                                    font-size: 12px;
                                                    text-align: right;
                                                }

                                                .portBox {
                                                    display: flex;
                                                    flex-direction: row-reverse;
                                                    align-items: center;
                                                    text-align: right;

                                                    .port {
                                                        font-size: 16px;
                                                        color: #181818;
                                                    }

                                                    .portName {
                                                        display: inline-block;
                                                        width: 75px;
                                                        margin-right: 6px;
                                                        overflow: hidden;
                                                        font-size: 12px;
                                                        color: #181818;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    }
                                                }
                                            }
                                        }

                                        .goodsDataBox {
                                            box-sizing: border-box;
                                            flex: 1;
                                            padding-left: 48px;
                                            font-size: 12px;
                                            color: #4d4d4d;
                                        }
                                    }

                                    .productDataBox {
                                        flex: 1;

                                        .dataDetailBox {
                                            box-sizing: border-box;
                                            height: 100%;
                                            padding-top: 5px;
                                            padding-left: 18px;

                                            .dataDetail {
                                                display: flex;
                                                flex-wrap: wrap;
                                                height: 81px;

                                                .dataItem {
                                                    display: flex;
                                                    width: 50%;
                                                    height: 17px;
                                                    padding-top: 10px;
                                                    font-size: 12px;

                                                    &:nth-child(2n-1) {
                                                        > .tit {
                                                            width: 90px;
                                                        }
                                                    }

                                                    > .tit {
                                                        box-sizing: border-box;
                                                        width: 111px;
                                                        height: 100%;
                                                        margin-right: 7px;
                                                        line-height: 15px;
                                                        color: #29a7de;
                                                        text-align: center;
                                                        border: 1px solid rgba(41, 167, 222, 0.5);
                                                        border-radius: 15px;
                                                    }

                                                    > span {
                                                        display: inline-block;
                                                        width: 70px;
                                                        overflow: hidden;
                                                        color: #181818;
                                                        text-overflow: ellipsis;
                                                        white-space: nowrap;
                                                    }
                                                }
                                            }

                                            .operatingBtn {
                                                display: block;
                                                width: 314px;
                                                height: 31px;
                                                margin-top: 10px;
                                                margin-left: 25px;
                                                line-height: 31px;
                                                color: white;
                                                text-align: center;
                                                cursor: pointer;
                                                background-color: #29a3da;
                                                border-radius: 31px;
                                                transition: all 0.25s;

                                                &:hover {
                                                    box-shadow: 1px 1px 5px #868686;
                                                }
                                            }
                                        }

                                        .notPassed {
                                            box-sizing: border-box;
                                            display: flex;
                                            height: 100%;
                                            padding: 20px 67px 0;

                                            .cry {
                                                .iconfont {
                                                    position: relative;
                                                    top: 5px;
                                                    font-size: 50px;
                                                    color: #29a3da;
                                                }
                                            }

                                            .textBox {
                                                box-sizing: border-box;
                                                flex: 1;
                                                padding-left: 20px;

                                                > div {
                                                    margin-bottom: 8px;

                                                    &:last-child {
                                                        margin-bottom: 0;
                                                    }
                                                }

                                                .txt1 {
                                                    width: 100%;
                                                    color: #e91c24;
                                                }

                                                .txt2 {
                                                    width: 200px;
                                                    max-height: 57px;
                                                    overflow: hidden;
                                                    color: #808080;
                                                    text-overflow: ellipsis;
                                                    word-break: break-all;
                                                }

                                                .txt3 {
                                                    font-size: 12px;
                                                    color: #afafaf;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            .noData {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                height: 100%;
                            }
                        }

                        .csWrap {
                            box-sizing: border-box;
                            display: flex;
                            flex-wrap: wrap;
                            height: 264px;
                            padding: 10px;

                            div.toolsBox {
                                border: none;
                            }

                            .toolsBox {
                                box-sizing: border-box;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: space-around;
                                width: calc((100% / 3) - 1px);
                                height: 50%;
                                cursor: pointer;
                                border-right: 1px solid rgba(149, 149, 149, 0.5);
                                border-bottom: 1px solid rgba(149, 149, 149, 0.5);

                                .iconfont {
                                    position: relative;
                                    top: 15px;
                                    display: inline-block;
                                    font-size: 36px;
                                    color: #29a3da;

                                    &.icon-shouhouguanli {
                                        transform: scale(0.8);
                                    }
                                }

                                > div.txt {
                                    position: relative;
                                    display: inline-block;
                                    color: #808080;
                                    text-align: center;
                                }

                                &:nth-child(3n) {
                                    border-right: none;
                                }

                                &:nth-child(4),
                                &:nth-child(5),
                                &:nth-child(6) {
                                    border-bottom: none;
                                }
                            }
                        }

                        .miaoToolsWrap {
                            box-sizing: border-box;
                            display: flex;
                            flex-wrap: wrap;
                            height: 264px;
                            padding: 10px;

                            .toolsBox {
                                box-sizing: border-box;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: space-around;
                                width: calc((100% / 3) - 1px);
                                height: 50%;
                                border-right: 1px solid rgba(149, 149, 149, 0.5);
                                border-bottom: 1px solid rgba(149, 149, 149, 0.5);

                                .iconfont {
                                    position: relative;
                                    top: 15px;
                                    display: inline-block;
                                    font-size: 36px;
                                    color: #29a3da;
                                }

                                > div.txt {
                                    position: relative;
                                    display: inline-block;
                                    color: #808080;
                                    text-align: center;
                                }

                                &:nth-child(3n) {
                                    border-right: none;
                                }

                                &:nth-child(4),
                                &:nth-child(5) {
                                    border-bottom: none;
                                }
                            }
                        }
                    }
                }

                .messageTab {
                    position: relative;
                    flex: 1;
                    height: 100%;
                    box-shadow: -5px 0 10px -5px #c3c3c3;

                    .messageShadowBox {
                        position: absolute;
                        top: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        height: 100%;

                        .messageShadow {
                            flex: 1;
                            border-top-right-radius: 6px;
                            border-bottom-right-radius: 6px;
                            box-shadow: 0 0 5px #c4c4c4;

                            &::before {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: calc(100% - 6px);
                                height: 100%;
                                content: '';
                                background-color: #d2edff;
                            }

                            &:last-child::after {
                                position: absolute;
                                right: 27px;
                                bottom: -11px;
                                width: 28px;
                                height: 24px;
                                content: '';
                                background-color: #d2edff;
                                box-shadow: 0 0 5px #c4c4c4;
                                transform: rotate(60deg) skew(29deg);
                            }
                        }
                    }

                    .messageItemBox {
                        position: absolute;
                        top: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        height: 100%;

                        .messageItem {
                            display: flex;
                            flex: 1;
                            flex-direction: column;
                            align-items: center;
                            justify-content: space-around;
                            background-color: #d2edff;
                            border-top-right-radius: 6px;
                            border-bottom-right-radius: 6px;
                            transition: 0.25s all;

                            &.active {
                                background-color: #29a3da;

                                .iconfont {
                                    color: white;
                                }

                                > span {
                                    color: white;
                                }
                            }

                            .iconfont {
                                position: relative;
                                top: 10px;
                                display: inline-block;
                                font-size: 34px;
                                color: #29a3da;
                            }

                            > span {
                                position: relative;
                                top: -3px;
                                display: inline-block;
                                width: 84px;
                                font-size: 12px;
                                color: #4d4d4d;
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
